import { useEffect, useState, useRef } from "react";
import TransactionAlert from "../../components/TransactionAlert";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import TrailDashboard from "../TrailDashboard";
import StatisticalRecord from "./StatisticalRecord";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Toast } from "primereact/toast";
import SectionSelection from "./SectionSelection";
import OrdersSection from "./Sections/OrdersSection";
import EnquiriesSection from "./Sections/EnquiriesSection";
import CampaignsSections from "./Sections/CampaignsSection";
import AgentsSections from "./Sections/AgentsSections";
import TicketsSections from "./Sections/TicketsSection";
// import "./style.module.scss";
import styles from './style.module.scss'
import { API_SUBSCRIPTION } from "../../api/auth.service";
import TrialModal from "./TrialModal";

ChartJS.register(ArcElement, Tooltip, Legend);


export const Dashboard = () => {
  let { transactionid } = useParams();
  const [status, setStatus] = useState(transactionid);
  const [transaction, setTransaction] = useState(false);
  const [recentOrderLoading, setRecentOrdersLoading] = useState(false);
  const [recentCampaignslaoding, setRecentCampaignsLoading] = useState(false);
  const { userSub } = useSelector((state) => state.authenticate);
  const toastRef = useRef(null);

  const [showTrialModal, setShowTrialModal] = useState(false);
  const [daysLeft, setDaysLeft] = useState(null);

  const triggerSubscriptionToast = async () => {
    try {
      const response = await API_SUBSCRIPTION(userSub.companyId);

      // Trial modal logic
      if (response?.subscription?.subscriptiontype?.name === "trial") {
        const endDate = new Date(response.subscription.endTime);
        const today = new Date();
        const diffTime = endDate - today;
        const daysRemaining = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        setDaysLeft(daysRemaining);
        setShowTrialModal(true);
      }

      if (response?.messageNotification?.isEnabled) {
        const { message, type } = response.messageNotification;
        toastRef.current.show({
          severity: type === "warning" ? "warn" : type,
          summary: message,
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Subscription Error:", error);
    }
  };

  useEffect(() => {
    triggerSubscriptionToast();
  }, []);

  useEffect(() => {
    setTransaction(true);
    setStatus(transactionid);
    if (status === "success") {
      setTransaction(true);
      setStatus(transactionid);
    }
  }, [userSub.userSubType]);

  const [analyticSection, setAnalyticSection] = useState("Enquiries");

  const section = () => {
    switch (analyticSection) {
      case "Enquiries":
        return <EnquiriesSection />;
      case "Campaigns":
        return <CampaignsSections />;
      case "Agents":
        return <AgentsSections />;
      case "Tickets":
        return <TicketsSections />;
      case "Orders":
        return <OrdersSection />;
      default:
        return <></>;
    }
  };

  return (
    <div className={`${styles.dashboard_container}  cp-10`}>
      <Loader visible={recentCampaignslaoding || recentOrderLoading} />
      <Toast ref={toastRef} position="top-center" />

      <TransactionAlert
        transaction={transaction}
        setTransaction={setTransaction}
        status={status}
      />

      {showTrialModal && daysLeft !== null && (
        <TrialModal daysLeft={daysLeft} onClose={() => setShowTrialModal(false)} />
      )}

      <div className={` cp-10 pt-0  m-auto h-auto`}>
        <div className="">
          <StatisticalRecord />
        </div>
      </div>
      <div className={` cp-10 pt-0 m-auto h-auto`}>
        <SectionSelection
          analyticSection={analyticSection}
          setAnalyticSection={setAnalyticSection}
        />
      </div>
      <div className={`cp-10 pt-0 m-auto h-auto`}>{section()}</div>
    </div>
  );
};

// === Inline Styles for the Modal ===
const modalBackdrop = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const modalContent = {
  backgroundColor: "#fff",
  padding: "30px",
  borderRadius: "12px",
  textAlign: "center",
  maxWidth: "500px",
  width: "90%",
  position: "relative",
};

const closeButton = {
  position: "absolute",
  top: "10px",
  right: "15px",
  fontSize: "20px",
  cursor: "pointer",
};

const buttonStyle = {
  padding: "10px 20px",
  backgroundColor: "#007bff",
  border: "none",
  borderRadius: "5px",
  color: "white",
  cursor: "pointer",
};
